import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Message } from 'primereact/message';
import { Checkbox } from 'primereact/checkbox';
import { isEmpty } from 'lodash';

import { setLastElement } from '../../../../../redux/Slices/scrollSlice';
import ScrollContainer from '../../../../SharedComponents/ScrollContainer';
import SearchInput from '../../../../SharedComponents/AddContentPopup/SearchInput';
import DeviceCard from './DeviceCard';

function DevicesList({ allSelected, setAllSelected, ids, setIds }) {
    const { t } = useTranslation();
    const { isFetching, data, params } = useSelector((state) => state.scroll);
    const lastElementRef = useRef(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if (lastElementRef.current) dispatch(setLastElement(lastElementRef.current));
    }, [lastElementRef.current]);

    useEffect(() => {
        if (data?.length > 0) setAllSelected(ids.length === data.length);
    }, [ids, data]);

    const selectAll = () => {
        if (!allSelected) {
            const allIds = data?.map((item) => String(item.id)) || [];
            setIds(allIds);
            setAllSelected(true);
        } else {
            setIds([]);
            setAllSelected(false);
        }
    };

    return (
        <>
            {/* Top controls */}
            <div className="w-100 d-flex flex-wrap align-items-center gap-2 mb-2">
                <div className="flex-grow-1">
                    <SearchInput isDisabled={data?.length === 0} />
                </div>

                <div className="d-flex align-items-center ms-auto">
                    <span className="me-2 text-muted d-none d-sm-inline">{t('buttons.select_all')}</span>
                    <Checkbox name="campaign" onChange={selectAll} checked={allSelected} />
                </div>
            </div>

            {/* Table header (lg+) */}
            <div className="d-none d-md-flex justify-content-between text-muted small w-100 px-1">
                <div className="col-2"> </div>
                <div className="col-3">{t('show.show_device_name')}</div>
                <div className="col-4">{t('show.show_playing_now')}</div>
                <div className="col-2">{t('table.status')}</div>
                <div className="col-1 text-end"> </div>
            </div>
            <hr className="w-100 mt-1 mb-2 d-none d-md-block" />

            {/* List */}
            <div className="scroll_container scroll_div w-100">
                <ScrollContainer path="/company/devices">
                    {data?.length === 0 && !isFetching ? (
                        <div className="d-flex p-5 justify-content-center">
                            <Message
                                className="fw-bold fs-6 p-3 w-100"
                                severity="warn"
                                text={
                                    isEmpty(params?.search)
                                        ? t('show.show_no_devices_yet')
                                        : t('messages.no_results')
                                }
                            />
                        </div>
                    ) : (
                        <>
                            {data?.map((item, index) => (
                                <div
                                    key={`${item.id}-${index}`}
                                    ref={index === data?.length - 1 ? lastElementRef : null}
                                    className={`card p-2 mb-2 border-1 ${ids.indexOf(String(item.id)) !== -1 ? 'border-2 pp-selected-border' : ''
                                        }`}
                                >
                                    <DeviceCard ids={ids} setIds={setIds} item={item} />
                                </div>
                            ))}
                        </>
                    )}
                </ScrollContainer>
            </div>
        </>
    );
}

export default DevicesList;
